import restApi from "@plannel/services/utils/rest-api";

/*
 * Supply Plan Dashboard(공급계획 현황) 데이터 서비스.
 * 독립 DW 기반 백엔드 조회 — **목업 없음, 전부 실데이터**.
 *   백엔드: GET /api/dashboard-dw/supply-plan (SupplyPlanDashboardController)
 *   소스: z_fact_mp_production(능력·생산·재고) + z_fact_mp_order(주문 충족·지연/부족·원인)
 *         + z_fact_ip_inventory(안전재고 조인)
 *   산식·컬럼 명세: saas-application/docs/sql/dw/dashboard-spec/03_supply_plan.md
 *
 * params: { currentDate?, locId?, resourceCd?, itemLevel? }  ★ 자원은 id 가 아니라 **코드**(ETL 이 resource_id 를 NULL 로 넣음)
 *
 * 응답 envelope: { currencyCd, period, availableBuckets, locations, resources,
 *                  itemLevels, itemLevel, itemGrouped,
 *                  kpis, spark, balance:{month,week}, invProjection:{month,week}, capacity:{month,week},
 *                  constraint[], shortageRows[], exceptionRows[] }
 *
 * ★ 품목 계층 레벨(itemLevel)은 **부족 상위 카드에만** 걸린다 — 나머지는 전 품목 합이라 레벨과 무관하다.
 *   itemGrouped=true 면 shortageRows 의 품목 두 컬럼(itemCd/itemNm)이 itemGrp 한 컬럼으로 바뀐다.
 */
const get = (params) => restApi.get("/api/dashboard-dw/supply-plan", { params });

const supplyPlanService = { get };

export default supplyPlanService;
